module.exports = __webpack_public_path__ + "img/H1F8_new.2d55eb36.jpg";